<template>
  <b-modal
    id="modal-agregar-os-manual"
    :title="messages.AGREGAR_MANUAL_MODAL_TITLE"
    size="lg"
    centered
    @hidden="handleHidden"
    @hide="handleHide"
    ><b-alert show variant="light" class="mb-3 gc-agregar-manual-context">
      Agregando OS a: <strong>{{ proveedorLabel || "—" }}</strong> · Periodo:
      <strong>{{ periodoLabel || "—" }}</strong>
    </b-alert>
    <b-form-group :label="messages.AGREGAR_MANUAL_SEARCH_PLACEHOLDER">
      <b-input-group>
        <b-form-input
          v-model="sequence"
          :placeholder="messages.AGREGAR_MANUAL_SEARCH_PLACEHOLDER"
          @keyup.enter="handleSearch"
        />
        <b-input-group-append>
          <b-button
            variant="outline-secondary"
            :disabled="searching"
            class="d-flex align-items-center justify-content-center gc-modal-btn"
            style="white-space: nowrap;"
            @click="handleSearch"
          >
            <b-spinner v-if="searching" small class="mr-1" />
            {{ messages.AGREGAR_MANUAL_SEARCH_BUTTON }}
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-alert v-if="searchError" show variant="danger">{{
      searchError
    }}</b-alert>
    <b-alert v-else-if="searched && !results.length" show variant="warning">
      {{ messages.AGREGAR_MANUAL_SEARCH_EMPTY }}
    </b-alert>

    <b-table
      v-if="results.length"
      small
      :items="results"
      :fields="resultFields"
    >
      <template #cell(quantity)="{ item }">
        <b-form-input
          v-if="osSeleccionada && osSeleccionada.detailId === item.detailId"
          v-model.number="cantidadOs"
          type="number"
          min="0"
          size="sm"
          style="width: 70px;"
          @blur="normalizarCantidad"
        />
        <span v-else>{{ item.quantity }}</span>
      </template>
    </b-table>
    <div v-if="osSeleccionada" class="mt-3">
      <b-alert
        v-if="osSeleccionada && cantidadOs === 0"
        show
        variant="warning"
        class="py-1 px-2 small"
      >
        Con cantidad 0 la OS no genera cobro; queda registrada sin monto.
      </b-alert>
      <div
        v-if="!adicionalDraft && !adicionales.length"
        class="border rounded text-center py-2 mb-3"
        style="border-style: dashed !important;"
      >
        <b-button
          variant="link"
          size="sm"
          class="text-decoration-none"
          @click="abrirFormAdicional"
        >
          + Agregar adicional <span class="text-muted">(opcional)</span>
        </b-button>
      </div>

      <div v-if="adicionales.length" class="border rounded mb-3">
        <div
          class="d-flex justify-content-between px-2 py-1 bg-light small text-muted"
        >
          <span>Adicionales</span><span>{{ adicionales.length }}</span>
        </div>
        <div
          v-for="(adicional, index) in adicionales"
          :key="index"
          class="d-flex justify-content-between align-items-center px-2 py-1 border-top small"
        >
          <span
            ><span class="text-muted mr-2">{{ letraOrden(index) }}</span
            >{{ adicional.skuServicio }} ·
            {{ adicional.descripcionServicio }}</span
          >
          <span class="d-flex align-items-center">
            <span class="text-muted mr-3">×{{ adicional.cantidad }}</span>
            <span class="mr-3"
              >S/
              {{
                (
                  Number(adicional.costoSinIgv) * Number(adicional.cantidad)
                ).toFixed(2)
              }}</span
            >
            <b-button
              size="sm"
              variant="link"
              class="text-danger p-0"
              @click="handleQuitarAdicional(index)"
              >Quitar</b-button
            >
          </span>
        </div>
      </div>
      <b-button
        v-if="adicionales.length && !adicionalDraft"
        size="sm"
        variant="link"
        class="text-decoration-none p-0 mb-3"
        @click="abrirFormAdicional"
      >
        + Agregar otro adicional
      </b-button>
      <GestorCentralizadoAdicionalForm
        v-if="adicionalDraft"
        :servicios-options="serviciosAdicionales"
        :value="adicionalDraft"
        :loading-servicio="loadingServicio"
        :loading-producto="loadingProducto"
        @buscar-servicio="buscarServicioAdicional"
        @buscar-producto="buscarProductoAdicional"
        @agregar="handleAgregarAdicional"
        @cancelar="adicionalDraft = null"
      />

      <!--<div
        v-if="adicionales.length"
        class="d-flex justify-content-between px-2 py-1 bg-light rounded small"
      >
        <span class="text-muted">Total adicionales</span>
        <strong>S/ {{ totalAdicionales }}</strong>
      </div> -->
    </div>
    <template #modal-footer>
      <b-button
        variant="secondary"
        class="gc-modal-btn"
        @click="$bvModal.hide('modal-agregar-os-manual')"
      >
        Cerrar
      </b-button>
      <b-button
        class="bg-orange-btn gc-modal-btn"
        :disabled="busy || !osSeleccionada"
        @click="handleGuardar"
      >
        <b-spinner v-if="busy" small class="mr-1" />
        Guardar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { buscarOsPorSecuencia } from "@/services/gestor-centralizado/gestor-centralizado.api";
import { MESSAGES } from "@/services/gestor-centralizado/gestor-centralizado.constants";
import {
  fetchServicioAdicionalCostos,
  fetchProductBySku,
  fetchAdditionalServicesCatalog,
} from "@/services/liquidaciones-proveedor/liquidaciones-proveedor.api";
import GestorCentralizadoAdicionalForm from "./GestorCentralizadoAdicionalForm.vue";
import { mapAdditionalServicesSelectOptions } from "@/services/liquidaciones-proveedor/liquidaciones-proveedor.mapper";
export default {
  name: "GestorCentralizadoAgregarManualModal",
  components: { GestorCentralizadoAdicionalForm },
  data() {
    return {
      serviciosAdicionales: [],
      messages: MESSAGES,
      sequence: "",
      results: [],
      searching: false,
      searched: false,
      searchError: "",
      pendingDetailId: null,
      resultFields: [
        { key: "sequence", label: "Nro. OS" },
        { key: "storeDescription", label: "Tienda" },
        { key: "providerName", label: "Proveedor" },
        { key: "service", label: "Servicio" },
        { key: "quantity", label: "Cant." },
        { key: "state", label: "Estado" },
        { key: "referenceDate", label: "Fecha" },
      ],
      osSeleccionada: null,
      adicionales: [],
      adicionalDraft: null,
      loadingServicio: false,
      loadingProducto: false,
      cantidadOs: 1,
    };
  },
  watch: {
    busy(value) {
      if (!value) this.pendingDetailId = null; // ← nuevo
    },
  },
  computed: {
    ...mapState("module", ["token"]),
    /*totalAdicionales() {
      return this.adicionales
        .reduce(
          (sum, a) =>
            sum + Number(a.costoSinIgv || 0) * Number(a.cantidad || 0),
          0,
        )
        .toFixed(2);
    },*/
  },
  props: {
    busy: {
      type: Boolean,
      default: false,
    },
    proveedorLabel: { type: String, default: "" },
    periodoLabel: { type: String, default: "" },
  },
  async mounted() {
    try {
      const data = await fetchAdditionalServicesCatalog({ token: this.token });
      this.serviciosAdicionales = mapAdditionalServicesSelectOptions(data);
    } catch (error) {
      this.serviciosAdicionales = [];
    }
  },
  methods: {
        normalizarCantidad() {
      const raw = this.cantidadOs;
      if (raw === "" || raw === null || raw === undefined) {
        this.cantidadOs = Number(this.osSeleccionada?.quantity ?? 1);
        return;
      }
      const n = Number(raw);
      this.cantidadOs =
        Number.isFinite(n) && n >= 0
          ? n
          : Number(this.osSeleccionada?.quantity ?? 1);
    },
    letraOrden(index) {
      return String.fromCharCode(65 + index); // A, B, C...
    },

    abrirFormAdicional() {
      this.adicionalDraft = {
        skuServicio: "",
        descripcionServicio: "",
        skuProducto: "",
        descripcionProducto: "",
        cantidad: 1,
        costoSinIgv: null,
        costoConIgv: null,
        obsProveedor: "",
      };
    },

    async buscarServicioAdicional(sku) {
      if (!sku || !this.osSeleccionada) return;
      this.loadingServicio = true;
      try {
        const data = await fetchServicioAdicionalCostos({
          skuServicio: sku,
          tiendaCodigo: this.osSeleccionada.storeId,
        });
        this.adicionalDraft = {
          ...this.adicionalDraft,
          skuServicio: sku,
          descripcionServicio: data.descripcionServicio,
          costoSinIgv: data.costoSinIgv,
          costoConIgv: data.costoConIgv,
        };
      } catch (error) {
        this.adicionalDraft = {
          ...this.adicionalDraft,
          descripcionServicio: "",
          costoSinIgv: null,
          costoConIgv: null,
        };
      } finally {
        this.loadingServicio = false;
      }
    },
    handleHide(evt) {
      const esDescarte = evt.trigger === "backdrop" || evt.trigger === "esc";
      if (esDescarte && this.osSeleccionada) {
        if (!window.confirm("Hay una OS sin guardar. ¿Descartar los cambios?"))
          evt.preventDefault();
      }
    },
    async buscarProductoAdicional(form) {
      if (!form.skuProducto) return;
      this.loadingProducto = true;
      try {
        const data = await fetchProductBySku(form.skuProducto, {
          token: this.token,
        });
        this.adicionalDraft = {
          ...this.adicionalDraft,
          skuProducto: form.skuProducto,
          descripcionProducto: data?.description || "",
        };
      } catch (error) {
        this.adicionalDraft = {
          ...this.adicionalDraft,
          descripcionProducto: "",
        };
      } finally {
        this.loadingProducto = false;
      }
    },
    handleSeleccionar(item) {
      if (
        this.adicionales.length &&
        this.osSeleccionada?.detailId !== item.detailId
      ) {
        if (
          !window.confirm(
            "Se descartarán los adicionales cargados. ¿Continuar?",
          )
        )
          return;
      }
      this.osSeleccionada = item;
      this.adicionales = [];
      this.cantidadOs = Number(item.quantity ?? 1);
    },

    handleAgregarAdicional(adicional) {
      this.adicionales.push({ ...adicional });
      this.adicionalDraft = null;
    },

    handleQuitarAdicional(index) {
      this.adicionales.splice(index, 1);
    },

    handleGuardar() {
      if (this.busy || !this.osSeleccionada) return;
      this.$emit("guardar", {
        idOsDet: this.osSeleccionada.detailId,
        cantidad: Number(this.cantidadOs),
        adicionales: this.adicionales.map((a) => ({
          skuServicio: a.skuServicio,
          skuProducto: a.skuProducto,
          cantidad: Number(a.cantidad),
          obsProveedor: a.obsProveedor,
        })),
      });
    },
    async handleSearch() {
      const value = this.sequence.trim();
      if (!value) return;

      this.searching = true;
      this.searchError = "";
      this.searched = false;
      this.results = [];
      try {
        this.results = await buscarOsPorSecuencia(value, { token: this.token });
        this.searched = true;
        if (this.results.length) this.handleSeleccionar(this.results[0]);
      } catch (error) {
        this.searchError = this.messages.AGREGAR_MANUAL_SEARCH_ERROR;
      } finally {
        this.searching = false;
      }
    },

    handleHidden() {
      this.sequence = "";
      this.results = [];
      this.searched = false;
      this.searchError = "";
      this.pendingDetailId = null;
      this.osSeleccionada = null;
      this.adicionales = [];
      this.adicionalDraft = null;
      this.cantidadOs = 1;
    },
  },
};
</script>
